/**
 * Supabase Client Configuration
 *
 * SECURITY: Uses environment variables (never hardcode credentials)
 *
 * SETUP INSTRUCTIONS:
 * 1. Copy .env.example to .env
 * 2. Get your Supabase project credentials from:
 *    https://app.supabase.com/project/_/settings/api
 * 3. Replace values in .env:
 *    - VITE_SUPABASE_URL
 *    - VITE_SUPABASE_ANON_KEY
 */

import { createClient } from '@supabase/supabase-js';

// TODO: Set VITE_SUPABASE_URL via environment variable
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

// TODO: Set VITE_SUPABASE_ANON_KEY via environment variable
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check .env file.\n' +
    'Required: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY'
  );
}

/**
 * Singleton Supabase client instance
 * Configured with:
 * - Automatic session refresh
 * - Persistent auth state in localStorage
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
});
